import { jwtDecode } from 'jwt-decode';

export default function useUserType() {
  try {
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    return decoded.tipo_usuario?.toLowerCase();
  } catch (error) {
    return null;
  }
}